import React, { useState, useEffect } from 'react';
import { drapcodeIcon } from '../../../common/custom/icon-library';
import cookie from 'react-cookies';
import {
  createRedirectUrl,
  handleSelectImage,
  handleSubmitSelection,
  formatModelType,
  openModal,
  closeModal,
} from './figma.util.js';
import FigmaHtmlTable from './FigmaHtmlTable.js';

const FigmaGetImage = ({
  projectId,
  version,
  figmaLink,
  aiModelConfigs,
  figmaImageData,
  deleteFigmaToHtmlData,
  fetchFigmaToHtmlData,
  generateFigmaToHtml,
}) => {
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedModel, setSelectedModel] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [currentImage, setCurrentImage] = useState(null);

  const availableModels = aiModelConfigs.filter(
    (model) => model.isEnabled && model.setting && model.setting.secretKey,
  );

  const token = cookie.load('token');
  let redirectUrl;
  let aiModelConfigurationURL;
  if (selectedImages.length > 0 && availableModels.length === 0) {
    redirectUrl = createRedirectUrl();
    aiModelConfigurationURL = `${redirectUrl}app-setting/${version}/v/${projectId}/setting/aiModelConfig-section`;
  }

  useEffect(() => {
    if (!selectedModel && availableModels.length > 0) {
      const defaultModel = availableModels.find((model) => model.isDefault);
      if (defaultModel) {
        setSelectedModel(defaultModel);
      }
    }
  }, [availableModels, selectedModel]);
  

  return (
    <div className="row ">
      <div className="col-md-12">
        {figmaImageData.length > 0 && <h3>Select Frames For Code</h3>}
        <div className="row g-3">
          {figmaImageData.map((data) => (
            <div key={data.id} className="col-6 col-md-4 col-lg-3">
              <div
                className={`card ${
                  selectedImages.some((img) => img.id === data.id)
                    ? 'border-success border-3 shadow'
                    : ''
                }`}
                onClick={() => openModal(data, setCurrentImage, setShowModal)}
                style={{ cursor: 'pointer', transition: '0.2s ease-in-out' }}
              >
                <img
                  src={data.image}
                  alt={data.name}
                  className="card-img-top"
                  style={{ height: '150px', objectFit: 'cover' }}
                />
                <div className="card-body text-center">
                  <p className="card-text">{data.name}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
        {selectedImages.length > 0 && availableModels.length > 0 && (
          <div className="form-group ml-3">
            <label style={{ marginBottom: '0px' }}>Select AI Model:</label>
            <div className="d-flex align-items-center">
              <div className="input-group w-100 d-flex align-items-center">
                <select
                  id="aiModelDropdown"
                  className="form-control w-auto px-3"
                  style={{ maxWidth: '200px' }}
                  value={selectedModel ? selectedModel.uuid : ''}
                  onChange={(e) => {
                    const model = availableModels.find((m) => m.uuid === e.target.value);
                    setSelectedModel(model || null);
                  }}
                >
                  <option value="" disabled>
                    - Choose AI Model -
                  </option>
                  {availableModels.map((model) => (
                    <option key={model.uuid} value={model.uuid}>
                      {formatModelType(model.modelType)}
                    </option>
                  ))}
                </select>
                <button
                  type="submit"
                  className={`btn ${
                    selectedModel ? 'btn-theme-submit' : 'btn-disabled'
                  } btn-md ml-3`}
                  onClick={() =>
                    handleSubmitSelection(
                      selectedImages,
                      selectedModel,
                      projectId,
                      version,
                      figmaLink,
                      setSelectedImages,
                      generateFigmaToHtml,
                    )
                  }
                  disabled={!selectedModel}
                  style={{ whiteSpace: 'nowrap' }}
                >
                  <i className="wb webconnect-rocket"></i>&nbsp;Generate&nbsp;
                </button>
              </div>
            </div>
          </div>
        )}
        {selectedImages.length > 0 && availableModels.length === 0 && (
          <div
            className=" d-flex justify-content-start align-items-center p-2 alert"
            role="alert"
            id="alertWarning"
            style={{
              color: '#856404',
              backgroundColor: '#fff3cd',
              borderColor: '#ffeeba',
            }}
          >
            <h5>
              <i className="fas fa-exclamation-triangle mx-2" aria-hidden="true"></i>
              Please configure the AI model in the{' '}
              <a
                className="text-primary ml-1 mr-1"
                href={aiModelConfigurationURL}
                target="_blank"
                rel="noopener noreferrer"
              >
                AI Model Configuration{' '}
                <i className="fas fa-external-link-alt" aria-hidden="true"></i>
              </a>
              section.
            </h5>
          </div>
        )}
      </div>
      {showModal && currentImage && (
        <div
          className="modal show d-block"
          tabIndex="-1"
          onClick={() => closeModal(setShowModal, setCurrentImage)}
        >
          <div
            className="modal-dialog modal-lg mt-5 modal-dialog-centered"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="modal-content">
              <div className="modal-body text-center">
                <img
                  src={currentImage.image}
                  alt={currentImage.name}
                  className="img-fluid"
                  style={{ maxHeight: '60vh', objectFit: 'contain' }}
                />
                <p className="mt-2">{currentImage.name}</p>
              </div>
              <div className="modal-footer">
                <button
                  className={`btn ${
                    selectedImages.some((img) => img.id === currentImage.id)
                      ? 'btn-theme-delete'
                      : 'btn-theme-submit'
                  }`}
                  onClick={() => {
                    handleSelectImage(currentImage, setSelectedImages);
                    closeModal(setShowModal, setCurrentImage);
                  }}
                >
                  {selectedImages.some((img) => img.id === currentImage.id) ? (
                    <>
                      <i className={`wb ${drapcodeIcon('go')}`}></i>&nbsp;Deselect&nbsp;
                    </>
                  ) : (
                    <>
                      <i className={`wb ${drapcodeIcon('select')}`}></i>&nbsp;select&nbsp;
                    </>
                  )}
                </button>
                <button
                  className="btn ml-2"
                  onClick={() => closeModal(setShowModal, setCurrentImage)}
                >
                  <i className={`wb ${drapcodeIcon('closeModal')}`}></i>&nbsp;close&nbsp;
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      <FigmaHtmlTable
        version={version}
        projectId={projectId}
        figmaLink={figmaLink}
        deleteFigmaToHtmlData={deleteFigmaToHtmlData}
        fetchFigmaToHtmlData={fetchFigmaToHtmlData}
      />
    </div>
  );
};

export default FigmaGetImage;
